export default {
  Danger: 'is-danger',
  Warning: 'is-warning',
  Success: 'is-success',
  Info: 'is-info',
  Primary: 'is-primary'
}

